import { debounce } from 'debounce';
import { lastActionKey } from '../constants/IdleTimeoutConstants';
export function startIdleTimeout(pollingCallback, pollingIntervalInMs) {
    let intervalTimer = null;
    setLastAction();
    if (pollingCallback) {
        intervalTimer = setInterval(() => pollingCallback(getLocalStorageLastAction()), pollingIntervalInMs && pollingIntervalInMs > 0 ? pollingIntervalInMs : 5000);
    }
    // Events that triggers timer reset
    window.onload = setLastAction;
    window.onfocus = setLastAction;
    window.onmousemove = debounce(setLastAction, 500);
    window.onmousedown = setLastAction; // catches touchscreen presses as well
    window.ontouchstart = setLastAction; // catches touchscreen swipes as well
    window.onclick = setLastAction; // catches touchpad clicks as well
    window.onkeydown = setLastAction;
    window.onscroll = setLastAction;
    window.ondblclick = setLastAction;
    window.oncontextmenu = setLastAction;
    window.onpageshow = setLastAction;
    window.onresize = debounce(setLastAction, 500);
    window.ondrag = debounce(setLastAction, 500);
    const stopTimer = () => {
        if (intervalTimer) {
            clearInterval(intervalTimer);
        }
    };
    return stopTimer;
}
function setLastAction() {
    const currentTime = Date.now();
    setLocalStorageLastAction(currentTime);
}
function getLocalStorageLastAction() {
    const timer = localStorage.getItem(lastActionKey);
    const convertedTimer = Number(timer); // returns 0 when "" or null, NaN if invalid
    return (timer && !!convertedTimer) ? convertedTimer : null;
}
function setLocalStorageLastAction(timer) {
    localStorage.setItem(lastActionKey, `${timer}`);
}
